//
// Generated class SupportShiftReport
//

/// <reference path="SupportShiftReport_ManagedObject.ts" />

class SupportShiftReport extends SupportShiftReport_ManagedObject
{

}
